"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** На странице создания вакансии это кнопка «Опубликовать» (оба кейса, списание и покупка публикации).
На странице редактирования вакансии это кнопка «Сохранить и продолжить».
Событие отправляется только когда аукцион подключён (выбран чекбокс в блоке).
 */
const auctionBlockCreateCampaignButtonClick = ({ vacancyId, draftId, vacancyAction, bidInCents, budgetInCents, maxBidAmongSimilarVacancies, useAvailableMoney, availableMoneyInCents, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("auction_block_create_campaign", { vacancyId, draftId, vacancyAction, bidInCents, budgetInCents, maxBidAmongSimilarVacancies, useAvailableMoney, availableMoneyInCents, ...analyticsParams });
exports.default = auctionBlockCreateCampaignButtonClick;
